import React from "react";
import OfferCountdown from "@/components/OfferCountdown";
import { isPackageOfferLimited } from "@/lib/utils-app";

export default function PackageAvailability({ pkg, publicView = false }) {
  if (!isPackageOfferLimited(pkg)) {
    if (!publicView) return null;
    return (
      <div
        className="mt-4 text-xs uppercase tracking-widest text-green-400/90 border border-green-500/30 bg-green-950/20 rounded-sm px-3 py-2"
        data-testid="package-indefinite-badge"
      >
        Disponible todo el año
      </div>
    );
  }
  return <OfferCountdown expiresAt={pkg.offer_expires_at} publicView={publicView} />;
}
